module.exports = __webpack_public_path__ + "media/svg/selection-steps-selected-d95dc035.svg";